import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { guardaGrupo } from "../actions/admin";
import AdminMenu from "../components/admin_menu";

class AdminGrupo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      nombre: "",
      orden: 1,
      estado: 1,
      loading: false
    };
    this.cambia = this.cambia.bind(this);
    this.envia = this.envia.bind(this);
    this.validaForm = this.validaForm.bind(this);
  }

  componentDidMount() {
    if (!this.props.usuario.user) {
      this.props.history.push("/login");
    }

    if (this.props.match.params.id) {
      var grupo = this.props.productos.prod.grupos.find((grupo, i) => {
        return grupo.id == this.props.match.params.id;
      });
      this.setState(grupo);
    } else {
        console.log(moment().unix());
      this.setState({
        id: this.props.productos.prod.id + "_" + moment().unix()
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.productos.contador > prevProps.productos.contador) {
      this.props.history.push(
        "/admin/producto/" + this.props.productos.prod.id
      );
    }
  }

  validaForm = () => {
    if (this.state.orden == "") {
      return {
        resp: false,
        msj: "DEBE COMPLETAR EL ORDEN"
      };
    } else {
      return {
        resp: true,
        msj: "PASO LA VALIDACION"
      };
    }
  };

  cambia = e => {
    var valor = e.target.value;
    if (e.target.type == "number") {
      valor = parseInt(valor);
    }
    this.setState({ [e.target.name]: valor });
  };

  envia = e => {
    this.setState({ loading: true }, () => {
      const valida = this.validaForm();

      if (valida.resp) {
        var grupos = [];

        const grupo = {
          id: this.state.id,
          nombre: this.state.nombre,
          orden: this.state.orden
        };

        if (this.props.productos.prod.hasOwnProperty("grupos")) {
          if (this.props.match.params.id) {
            grupos = this.props.productos.prod.grupos.map(g => {
              if (g.id == this.state.id) {
                return grupo;
              } else {
                return g;
              }
            });
          } else {
            grupos = Object.assign([], this.props.productos.prod.grupos)
            grupos.push(grupo)
          }
        } else {
          grupos.push(grupo);
        }
        this.props.guardaGrupo(this.props.productos.prod.id, grupos);
      } else {
        this.setState({
          alert: valida.msj,
          loading: false
        });
      }
    });
  };

  render() {
    if (this.state.loading) {
      return <div>CARGANDO</div>;
    }
    return (
      <div className="container">
        <section className="row mb-5 sombraHead mt-3 clearfix">
          <div className="col-md-3 mb-3">
            <AdminMenu />
          </div>

          <div className="col-md-9 p-3">
            <div className="container">
              <div>
                <h1 className="display-4">Rubro</h1>
              </div>
              <div className="form-group">
                <label>Nombre</label>
                <input
                  type="text"
                  className="form-control"
                  name="nombre"
                  value={this.state.nombre}
                  onChange={this.cambia}
                />
              </div>
              <div className="form-group">
                <label>ORDEN</label>
                <input
                  type="number"
                  className="form-control"
                  name="orden"
                  value={this.state.orden}
                  onChange={this.cambia}
                />
              </div>
              <div className="form-row">
                {this.props.match.params.id ? (
                  <button
                    type="submit"
                    className="btn btn-primary"
                    onClick={this.envia}
                  >
                    ACTUALIZAR
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="btn btn-primary"
                    onClick={this.envia}
                  >
                    AGREGAR
                  </button>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    productos: state.productos,
    usuario: state.usuario
  };
};

const mapDispatchToProps = dispatch => {
  return {
    guardaGrupo: (id_producto, datos) => {
      dispatch(guardaGrupo(id_producto, datos));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminGrupo);



// WEBPACK FOOTER //
// ./src/containers/grupo_form.js